/**
 * @Description 发起点位评估弹框(益禾堂无址)
 */
import { FC, useEffect, useMemo, useRef } from 'react';
import { Form, Modal } from 'antd';
import { useMethods } from '@lhb/hook';
import V2Form from '@/common/components/Form/V2Form';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { passTaskChancepoint } from '@/common/api/expandStore/expansiontask';
import styles from './index.module.less';
import { isArray, isNotEmptyAny } from '@lhb/func';
import MeituanReport from '@/common/components/business/ExpandStore/TaskDetailCommon/CreateSpotApproval/components/MeituanReport';
import { ControlType, parseValueCatch, uploadValToJSON } from '../../../DynamicComponent/config';
import { SavePropertyValues } from './ts-config';
import EstimateSalesOfYht from './EstimateSalesOfYht';

interface Props {
	passModal;
	setPassModal;
  title;
  refresh;
}

const DirectPassSpotApproval: FC<Props> = ({
  passModal,
  setPassModal,
  title,
  refresh
}) => {
  const [form] = Form.useForm(); // 表单参数
  const isLockRef = useRef<boolean>(false);

  useEffect(() => {
    const { mtProperty } = passModal || {};
    if (isNotEmptyAny(mtProperty)) {
      const val = parseValueCatch(mtProperty) || [];
      form.setFieldValue(mtProperty.identification, val);
    }
  }, [passModal.mtProperty]);

  /**
   * @description 是否需要展示美团报告
   */
  const showUploadFile = useMemo(() => {
    return isNotEmptyAny(passModal?.mtProperty);
  }, [passModal?.mtProperty]);

  const methods = useMethods({
    onOk() {
      form
        .validateFields()
        .then(async (values: any) => {
          if (isLockRef.current) return;

          // 动态字段
          const propertyValues: SavePropertyValues[] = [];
          // 美团报告
          const { mtProperty } = passModal;
          if (showUploadFile && mtProperty) {
            const attachments = values[mtProperty.identification];
            if (isArray(attachments) && attachments.length) {
              let uploadIsComplete = true;
              attachments.forEach((uploadComItem: any) => {
                const { url } = uploadComItem;
                if (!url) {
                  uploadIsComplete = false;
                }
              });
              if (!uploadIsComplete) {
                V2Message.warning('文件上传中...');
                return;
              };
            }
            propertyValues.push({
              id: mtProperty.id,
              propertyId: mtProperty.propertyId,
              identification: mtProperty.identification,
              textValue: uploadValToJSON(attachments),
            });
          }
          if (passModal?.estimateSale) {
            const { estimateSale } = passModal;
            // 美团竞品均值
            const mtMeanCom = estimateSale.find((item) => item.controlType === ControlType.ESTIMATE_SALES_MT_MEAN_YHT.value);
            mtMeanCom && (propertyValues.push({
              id: mtMeanCom.id,
              propertyId: mtMeanCom.propertyId,
              identification: mtMeanCom.identification,
              textValue: values[mtMeanCom.identification]
            }));
            // 美团竞品高值
            const mtMaxCom = estimateSale.find((item) => item.controlType === ControlType.ESTIMATE_SALES_MT_MAX_YHT.value);
            mtMaxCom && (propertyValues.push({
              id: mtMaxCom.id,
              propertyId: mtMaxCom.propertyId,
              identification: mtMaxCom.identification,
              textValue: values[mtMaxCom.identification],
            }));
          }

          const { chancePointId, taskId } = passModal;
          isLockRef.current = true;
          passTaskChancepoint({
            id: taskId,
            chancePointId,
            ...(propertyValues.length ? { directSavePropertyValues: propertyValues } : {})
          }).then(() => {
            V2Message.success('提交成功');
            form.resetFields();
            setPassModal({
              show: false,
              chancePointId: undefined,
              taskId: undefined
            });
            refresh();
          });
        })
        .catch((error) => {
          console.error('提交失败:', error);
        })
        .finally(() => {
          isLockRef.current = false;
        });
    },

    /** 点击取消 */
    onCancel() {
      form.resetFields();
      setPassModal({
        show: false,
        chancePointId: undefined,
        taskId: undefined,
      });
    },
  });
  return (
    <>
      <Modal
        title={title}
        open={passModal.show}
        onOk={methods.onOk}
        // 两列弹窗要求336px
        width={showUploadFile ? 480 : 336}
        onCancel={methods.onCancel}
        forceRender
        className={styles.createModal}
      >
        <V2Form form={form}>
          {showUploadFile ? <MeituanReport
            propertyItem={passModal?.mtProperty}
          /> : <></>}
          {/*  三个预测营业额 */}
          {passModal?.estimateSale ? <EstimateSalesOfYht
            propertyItems={passModal?.estimateSale}
            form={form}
          /> : <></>}
        </V2Form>
      </Modal>
    </>
  );
};
export default DirectPassSpotApproval;
